module.exports = __webpack_public_path__ + "img/twitter-icon.73a49f63.svg";